import { createApi } from "@reduxjs/toolkit/query/react";
import * as config from "config";
import * as utils from "utils";

const baseQuery = async (args, api, extraOptions) => {
  try {
    const response = await utils.authenticatedFetch(
      config.endpoints.user(args.url),
      args.payload || {}
    );
    return {
      data: await response.json(),
    };
  } catch (e) {
    return {
      error: String(e),
    };
  }
};

export const userServiceApi = createApi({
  reducerPath: "userApi",
  baseQuery: baseQuery,
  tagTypes: ["UserPreferences"],
  endpoints: (builder) => ({
    whereAmI: builder.query({
      query: () => ({
        url: "where-am-i",
      }),
    }),
    attributes: builder.query({
      query: () => ({
        url: "attributes",
      }),
    }),
    retrieveConfig: builder.query({
      query: ({ companyId }) => ({
        url: `user-config/${companyId}`,
      }),
    }),
    // User Preferences endpoints
    retrievePreferences: builder.query({
      query: () => ({
        url: "preferences",
      }),
      providesTags: ["UserPreferences"],
    }),
    updatePreferences: builder.mutation({
      query: (preferences) => ({
        url: "preferences",
        payload: {
          method: "POST",
          body: JSON.stringify(preferences),
          headers: { "Content-Type": "application/json" },
        },
      }),
      invalidatesTags: ["UserPreferences"],
    }),
  }),
});

export const {
  useWhereAmIQuery,
  useAttributesQuery,
  useRetrieveConfigQuery,
  useRetrievePreferencesQuery,
  useUpdatePreferencesMutation,
} = userServiceApi;
